import create from 'zustand/vanilla';
import { CustomerDetail } from '@/services/customer.service';

/**
 * 고객관리 회원 상세 화면 상태.
 * - 선택된 회원 ID, 상세 데이터, 로딩 상태, 목록 필터를 관리한다.
 */
export type CustomerFilter = 'all' | 'once' | 'repeat';

interface CustomerDetailState {
    selectedCustomerId: string | null;
    detail: CustomerDetail | null;
    isDetailLoading: boolean;
    filter: CustomerFilter;
    productFilter: string | null; // 구매 상품(그룹)명 기준 필터 (null = 전체)
}

export interface CustomerDetailStore extends CustomerDetailState {
    setSelectedCustomerId: (id: string | null) => void;
    setDetail: (detail: CustomerDetail | null) => void;
    setDetailLoading: (loading: boolean) => void;
    setFilter: (filter: CustomerFilter) => void;
    setProductFilter: (productName: string | null) => void;
    patchDetail: (patch: Partial<CustomerDetail>) => void;
    clear: () => void;
}

const initializeState: CustomerDetailState = {
    selectedCustomerId: null,
    detail: null,
    isDetailLoading: false,
    filter: 'all',
    productFilter: null,
};

export const customerDetailStore = create<CustomerDetailStore>((set) => ({
    ...initializeState,

    setSelectedCustomerId: (id) => set({ selectedCustomerId: id }),
    setDetail: (detail) => set({ detail }),
    setDetailLoading: (loading) => set({ isDetailLoading: loading }),
    setFilter: (filter) => set({ filter }),
    setProductFilter: (productName) => set({ productFilter: productName }),
    patchDetail: (patch) =>
        set((state) => ({
            detail: state.detail ? { ...state.detail, ...patch } : state.detail,
        })),
    clear: () => set(initializeState),
}));

export default customerDetailStore;
